var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEconomies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17C3.80545 17 0 13.1946 0 8.5C0 3.80545 3.80545 0 8.5 0C13.1946 0 17 3.80545 17 8.5C17 13.1946 13.1946 17 8.5 17ZM6.8425 7.65C6.91613 7.28847 7.08263 6.95234 7.3256 6.67469C7.56857 6.39704 7.87965 6.18743 8.22822 6.0665C8.57678 5.94556 8.95083 5.91747 9.31356 5.98497C9.67628 6.05248 10.0152 6.21326 10.2969 6.4515L11.7419 5.48845C11.2454 4.94765 10.6038 4.56115 9.8936 4.3751C9.18342 4.18904 8.4347 4.2113 7.73682 4.4392C7.03895 4.66711 6.4214 5.09103 5.95791 5.66037C5.49442 6.22971 5.20457 6.9204 5.12295 7.65H4.25V9.35H5.12295C5.20442 10.0798 5.49424 10.7707 5.95779 11.3402C6.42133 11.9097 7.03901 12.3337 7.73705 12.5617C8.4351 12.7896 9.18399 12.8118 9.8943 12.6256C10.6046 12.4394 11.2463 12.0526 11.7428 11.5115L10.2969 10.5476C10.0152 10.7859 9.67628 10.9467 9.31356 11.0142C8.95083 11.0817 8.57678 11.0536 8.22822 10.9327C7.87965 10.8117 7.56857 10.6021 7.3256 10.3245C7.08263 10.0468 6.91613 9.71068 6.8425 9.34915H11.05V7.64915L6.8425 7.65Z",
    fill: "#385745"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEconomies);
export default __webpack_public_path__ + "static/media/Economies.3b609deb0563f425974802538d6ae6d5.svg";
export { ForwardRef as ReactComponent };